import { create } from 'zustand';
import type {
  EnrichmentStore,
  EnrichmentFromType,
  PendingAdvancedSearchRedirect,
  TableEnrichmentSelectionState,
} from './types';

export const useEnrichmentStore = create<EnrichmentStore>(set => ({
  enrichmentFrom: undefined,

  setEnrichmentFrom: (data: EnrichmentFromType) => {
    set({ enrichmentFrom: data });
  },

  clearEnrichmentFrom: () => {
    set({ enrichmentFrom: undefined });
  },

  pendingAdvancedSearchRedirect: undefined,

  setPendingAdvancedSearchRedirect: (data: PendingAdvancedSearchRedirect) => {
    set({ pendingAdvancedSearchRedirect: data });
  },

  clearPendingAdvancedSearchRedirect: () => {
    set({ pendingAdvancedSearchRedirect: undefined });
  },

  tableEnrichmentSelection: undefined,

  setTableEnrichmentSelection: (data: TableEnrichmentSelectionState) => {
    set({ tableEnrichmentSelection: data });
  },

  clearTableEnrichmentSelection: () => {
    set({ tableEnrichmentSelection: undefined });
  },
}));
